/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { TransportProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const transportProcessFetchTransportProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const transportProcessFetchTransportProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [TransportProcessTypes.TRANSPORT_PROCESS_FETCH_TRANSPORT_PROCESS_LOADING]: transportProcessFetchTransportProcessLoading,
  [TransportProcessTypes.TRANSPORT_PROCESS_FETCH_TRANSPORT_PROCESS_SUCCESS]: transportProcessFetchTransportProcessSuccess
});
